/**
 * Spec 018 (legacy coexistence) write-authority vocabulary shared by the
 * document client, the provider, and the 409 discriminator
 * (contracts/write-authority-config.md). Never-flip and excluded domains
 * are not keys: absence from a document evaluates to read-only.
 */
export const WRITE_AUTHORITY_SCHEMA = "write-authority.v1" as const;

export const WRITE_AUTHORITY_DOMAINS = [
  "persons",
  "companies_locations",
  "financial",
  "subscriptions",
  "events",
  "compliance_npn",
  "reference",
] as const;

export type WriteAuthorityDomain = (typeof WRITE_AUTHORITY_DOMAINS)[number];

export type DomainAuthority = "legacy" | "new";

export function isWriteAuthorityDomain(value: unknown): value is WriteAuthorityDomain {
  return (
    typeof value === "string" && (WRITE_AUTHORITY_DOMAINS as readonly string[]).includes(value)
  );
}
